import { Component, OnInit } from "@angular/core";

import { ConfigsService } from "../configs.service";
import { Http } from "@angular/http";
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { forEach } from "@angular/router/src/utils/collection";

declare var $: any;
declare var swal: any;

@Component({
  selector: "app-dietas",
  templateUrl: "./dietas.component.html",
  styleUrls: ["./dietas.component.css"],
})
export class DietasComponent implements OnInit {
  // indico o nome da tabela que irá ter a tabela
  nomeTabela: string = "#listaDietas";
  // guardo código do hospital em variável
  dadosHospital: any = JSON.parse(sessionStorage.getItem("hospital"));
  codHospital: any = this.dadosHospital.cod_hospital;
  dtAtualizacao: any;

  constructor(
    private http: Http,
    private config: ConfigsService,
    private titulo: Title,
    private rota: Router
  ) {
    // indico o título da página
    this.titulo.setTitle("Listar Dietas - " + this.config.nome);
  }

  // #########################################
  // FUNÇÃO PARA ATUALIZAR REGISTROS DA TABELA
  // #########################################
  atualizaTabela() {
    // bloqueia tela até a completa atualização dos registros
    $.bloqueiaTela();
    // imprime na tela
    this.inicializaTabela(-1);
  }

  // função para filtrar as dietas de acordo com o status
  filtraDietas(filtro) {
    $.bloqueiaTela();

    this.http
      .get(
        `${this.config.urlApi}/dietas/hospital/${this.codHospital}/permissao/${this.permissaoConselho}`
      )
      .subscribe((response) => {
        // guardo em variável
        var dadosRetornados = response.json();
        // var dataAtu = new Date().getTime().toString();
        // sessionStorage.setItem("listaDietas", JSON.stringify(dadosRetornados));
        // sessionStorage.setItem("listaDietasAtu", dataAtu);
        this.inicializaTabelaDataTable(dadosRetornados);

        var dadosRetornados = JSON.parse(sessionStorage.getItem("listaDietas"));
        var arrayTemp = [];

        if (filtro > 0) {
          dadosRetornados.forEach((d) => {
            switch (filtro) {
              case 1: // verde
                if (
                  d.status_prescricao == 2 &&
                  !d.cancelamento_dt &&
                  d.assinatura_md
                )
                  arrayTemp.push(d);
                break;
              case 2: // azul
                if (
                  d.status_prescricao == 1 &&
                  !d.cancelamento_dt &&
                  d.assinatura_md
                )
                  arrayTemp.push(d);
                break;
              case 3: // roxo
                if (
                  d.status_prescricao == 1 &&
                  !d.assinatura_md &&
                  !d.cancelamento_dt
                )
                  arrayTemp.push(d);
                break;
              case 4: // vermelho
                if (d.cancelamento_dt) arrayTemp.push(d);
                break;
              case 5: // cinza
                if (d.status_prescricao == 0 && !d.cancelamento_dt)
                  arrayTemp.push(d);
                break;
              case 0: // resto
                arrayTemp.push(d);
                break;
              default:
                arrayTemp.push(d);
                break;
            }
          });
        } else {
          arrayTemp = dadosRetornados;
        }

        if (arrayTemp.length > 0) {
          this.inicializaTabelaDataTable(arrayTemp);
        } else {
          $.desbloqueiaTela();
          swal("Oops.", "Não há dietas com este filtro", "info");
        }
      });
    // $.desbloqueiaTela();
  }

  // insere dados na tabela
  inicializaTabelaDataTable(response) {
    var dadosRetornados = response;

    if (dadosRetornados.length > 0) {
      // formata data para retorno
      var dataCapturada = new Date(dadosRetornados[0].data_atu);
      let data = new Date();
      var d_dataCapturada: any = dataCapturada.getDate();
      var m_dataCapturada: any = dataCapturada.getMonth() + 1;
      var y_dataCapturada = dataCapturada.getFullYear();
      var h_dataCapturada: any = dataCapturada.getHours() + 3;
      var mm_dataCapturada: any = dataCapturada.getMinutes();

      if (m_dataCapturada < 10) m_dataCapturada = "0" + m_dataCapturada;
      if (mm_dataCapturada < 10) mm_dataCapturada = "0" + mm_dataCapturada;
      if (h_dataCapturada < 10) h_dataCapturada = "0" + h_dataCapturada;
      if (d_dataCapturada < 10) d_dataCapturada = "0" + d_dataCapturada;

      if (
        d_dataCapturada &&
        m_dataCapturada &&
        y_dataCapturada &&
        h_dataCapturada &&
        mm_dataCapturada
      ) {
        this.dtAtualizacao =
          "(Sincronizada em: " +
          d_dataCapturada +
          "/" +
          m_dataCapturada +
          "/" +
          y_dataCapturada +
          " " +
          h_dataCapturada +
          ":" +
          mm_dataCapturada +
          ").";
      } else {
        this.dtAtualizacao = "";
      }

      // CRIA TABELA
      $(this.nomeTabela).DataTable({
        data: dadosRetornados,
        responsive: true,
        destroy: true,
        aaSorting: [],
        order: [0, "desc"],
        columnDefs: [{ type: "date-uk", targets: 4 }],
        fnRowCallback: function (
          nRow,
          aData,
          iDisplayIndex,
          iDisplayIndexFull
        ) {
          //verde
          if (
            aData.status_prescricao == 2 &&
            !aData.cancelamento_dt &&
            aData.assinatura_md
          ) {
            $(nRow).css("background", "#e2ffe2");
          }
          //azul
          if (
            aData.status_prescricao == 1 &&
            !aData.cancelamento_dt &&
            aData.assinatura_md
          ) {
            $(nRow).css("background", "#dae8ff");
          }
          //roxo
          if (
            aData.status_prescricao == 1 &&
            !aData.assinatura_md &&
            !aData.cancelamento_dt
          ) {
            $(nRow).css("background", "#eedaff");
          }
          //cinza
          if (aData.status_prescricao == 0 && !aData.cancelamento_dt) {
            $(nRow).css("background", "#ececec");
          }
          //vermelho
          if (aData.cancelamento_dt) {
            $(nRow).css("background", "#ffd9d9");
          }
        },
        columns: [
          { data: "codigo_atend" },
          { data: "codigo" },
          { data: "nomecliente" },
          { data: "convenio" },
          { data: "cadastro_dt" },
          { data: "tipo_dieta" },
          { data: "local_tratamento" },
          { data: "localpaciente" },
        ],
      });
    } else {
      swal("Oops.", "Não há dietas neste hospital.", "info");
    }
    // libera tela
    $.desbloqueiaTela();
  }
  // #########################################
  // FUNÇÃO PARA IMPRESSÃO DA TABELA DE DIETAS
  // #########################################
  inicializaTabela(atualizarForcado = 0) {
    // if (atualizarForcado == -1) {
    //   sessionStorage.removeItem("listaDietasAtu");
    //   sessionStorage.removeItem("listaDietas");
    // }

    // if (sessionStorage.getItem("listaDietasAtu")) {
    //   var novaData = new Date().getTime().toString();
    //   if (
    //     parseInt(novaData) >
    //     parseInt(sessionStorage.getItem("listaDietasAtu")) + 3 * 60 * 1000
    //   ) {
    //     sessionStorage.removeItem("listaDietasAtu");
    //     sessionStorage.removeItem("listaDietas");
    //   }
    // }

    // if (sessionStorage.getItem("listaDietas")) {
    //   var dadosRetornados = JSON.parse(sessionStorage.getItem("listaDietas"));
    //   this.inicializaTabelaDataTable(dadosRetornados);
    // } else {
    // trago as dietas vinculadas ao hospital
    this.http
      .get(
        `${this.config.urlApi}/dietas/hospital/${this.codHospital}/permissao/${this.permissaoConselho}`
      )
      .subscribe((response) => {
        // guardo em variável
        var dadosRetornados = response.json();
        var dataAtu = new Date().getTime().toString();

        this.inicializaTabelaDataTable(dadosRetornados);
      });
  }

  // ######################################################
  // AÇÕES A SEREM EXECUTADAS ENQUANTO A PÁGINA É CARREGADA
  // ######################################################
  permissaoConselho: any = 0;
  async ngOnInit() {
    let codigoMedicoAutenticado = JSON.parse(
      sessionStorage.getItem("autenticacao")
    ).codigo;
    let conselhoMedicoAutenticado = JSON.parse(
      sessionStorage.getItem("autenticacao")
    ).sigla;
    let valida = await this.config
      .validaConselho(codigoMedicoAutenticado, conselhoMedicoAutenticado)
      .then((r) => r);
    this.permissaoConselho = valida;

    // bloqueia a tela enquanto carrega dados
    $.bloqueiaTela();
    // chama função para iniciar tabela
    this.inicializaTabela();
    // declaro em variável a rota
    var novaRota = this.rota;

    // FUNÇÃO PARA QUANDO CLICAR EM UMA LINHA
    $(this.nomeTabela).on("click", "tbody tr", function () {
      // busca a linha clicada
      var tdClicada = $(this).find("td")[0];
      var valorClicado = $(tdClicada).text();

      novaRota.navigate(["/dietas/editar/dieta/", valorClicado]);

      // mostra modal com informações
      // swal({
      // 	title: 'O que deseja fazer com esta dieta?',
      // 	type: 'warning',
      // 	showCancelButton: true,
      // 	confirmButtonColor: '#3085d6',
      // 	cancelButtonColor: '#1fa1be',
      // 	showCloseButton: true,
      // 	confirmButtonText: 'Editar',
      // 	cancelButtonText: 'Cancelar'
      // }).then((result) => {
      // 	// se for clicado no botão "Editar", vai para a edição da dieta
      // 	if (result.value){
      // 		this.rota
      // 		novaRota.navigate(['/dietas/editar/dieta/', valorClicado]);
      // 	}
      // });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dietas/dietas.component.ts